import { useState, useEffect } from 'react';
import { DlqRedriveInfoApiFactory } from '../../../lusca-search-api/LuscaSearchApiFactory';
import { Stage, DLQRedriveInfoResult } from '../../../lusca-search-api/generated-src';

export const useDlqRedriveDetails = (stage: Stage, executionArn: string | null) => {
  const [details, setDetails] = useState<DLQRedriveInfoResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (!executionArn) {
      setDetails(null);
      return;
    }

    const fetchDetails = async () => {
      try {
        setLoading(true);
        setError("");

        const dlqRedriveApi = DlqRedriveInfoApiFactory();
        const response = await dlqRedriveApi.getDLQRedriveInfo(stage, executionArn);

        setDetails(response.data);
      } catch (error) {
        console.error("Error fetching DLQ redrive details:", error);
        setError("Failed to load DLQ redrive details");
        setDetails(null);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [stage, executionArn]);

  return { details, loading, error };
};
